var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96985 3.525L5.11719 4.38911L3.58794 2.83933V10.8889H2.38191V2.83933L0.853266 4.38911L0 3.525L2.98492 0.5L5.96985 3.525ZM12 8.475L9.01507 11.5L6.03015 8.475L6.88281 7.61089L8.41266 9.16067L8.41206 1.11111H9.61809V9.16067L11.1473 7.61089L12 8.475V8.475Z",
    fill: "#FF4B53"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.e3ad0267a6b484b5fe571b4c17395193.svg";
export { ForwardRef as ReactComponent };